import React, { useState } from 'react';
import dayjs, { type Dayjs } from 'dayjs';

import { StyledDatePicker } from 'components/Input/styles';

import type { CellValue } from '../types';
import { StyledCellInputWrapper } from '../styles';

interface DateCellProps {
  value: CellValue;
  readOnly: boolean;
  onChange: (next: CellValue) => void;
}

export const DateCell: React.FC<DateCellProps> = ({ value, readOnly, onChange }) => {
  const [open, setOpen] = useState(false);
  const dateValue = typeof value === 'string' && value ? dayjs(value) : null;

  return (
    <StyledCellInputWrapper>
      <StyledDatePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        format="DD/MM/YYYY"
        value={dateValue && dateValue.isValid() ? dateValue : null}
        onChange={(date: Dayjs | null) => {
          if (date && date.isValid()) {
            onChange(date.toISOString());
          } else {
            onChange(null);
          }
        }}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            onClick: () => {
              if (!readOnly) setOpen(true);
            },
          },
        }}
        readOnly={readOnly}
      />
    </StyledCellInputWrapper>
  );
};
